export const GET_GEOFENCES_GROUP = "GET_GEOFENCES_GROUP";
export const GET_GEOFENCES_GROUP_RESULT = "GET_GEOFENCES_GROUP_RESULT";
export const MAP_GEOFENCES_UPDATE_ADD_GEOFENCE_GROUP = "MAP_GEOFENCES_UPDATE_ADD_GEOFENCE_GROUP";
export const MAP_GEOFENCE_LIST_GETTAGS = "MAP_GEOFENCE_LIST_GETTAGS";
export const MAP_GEOFENCE_LIST_GETTAGS_RESPONSE = "MAP_GEOFENCE_LIST_GETTAGS_RESPONSE";
export const MAP_GEOFENCE_LIST_GETTAGS_TOCREATE = "MAP_GEOFENCE_LIST_GETTAGS_TOCREATE";
export const MAP_GEOFENCE_LIST_GETTAGS_TOCREATE_RESPONSE = "MAP_GEOFENCE_LIST_GETTAGS_TOCREATE_RESPONSE";